import { StatusCodes } from "http-status-codes";
import { request } from "../../api";
import { headers } from "../../../../config/config";
import { MESSAGE } from "../../../../constants/api/message";
import { AUTHORIZATION } from "../../../../constants/api/auth";

const { post, get, patch, put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export type InvalidSubPlanPayload = {
	group_number: number;
	base_plan_name: string;
};

const initialRoute = "reports";

export const invalidSubPlanReport = async (invalidSubPlanPayload: InvalidSubPlanPayload) => {
	try {
		const payload = JSON.stringify(invalidSubPlanPayload);
		const endpoint = `${initialRoute}/VEB/invalid-sub-plan`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
